import { useEffect, useState } from 'react';
import api from '../api';

export default function useSymbolTrie() {
    const [trie, setTrie] = useState(null);

    useEffect(() => {
        async function load() {
            try {
                const res = await api.get('/stocks/symbols/tree');
                setTrie(res.data);
            } catch (err) {
                console.error("Failed to load symbol trie", err);
            }
        }
        load();
    }, []);

    const searchPrefix = (prefix) => {
        let node = trie;
        for (const char of prefix.toUpperCase()) {
            if (!node?.[char]) return false;
            node = node[char];
        }
        return true;
    };

    return { trie, searchPrefix };
}
